import { BaseService } from '@services/BaseService';
import { AuthorizationPromptViewModel } from '@models/AuthorizationPrompt';
import { OptionsViewModel } from '../_models/common.models';

class CVIService extends BaseService {
  constructor() {
    super('cvi');
  }
  getCVIPrompts(id: number): Promise<Array<AuthorizationPromptViewModel>> {
    return this.fetch(`${id}/prompts`);
  }

  getBrands(id: number): Promise<Array<OptionsViewModel>> {
    return this.fetch<Array<OptionsViewModel>>(`${id}/brands`);
  }
}

export const cviService = new CVIService();



// WEBPACK FOOTER //
// ./src/_services/CVIService.ts